// Timing rules for the summary poll. Pure functions only.

const BACKOFF_MS = [15000, 30000, 60000]

// Network/5xx failures retry after 15, 30, then every 60 seconds.
export function nextDelay(failures, pollIntervalMs) {
    if (!failures) return pollIntervalMs
    return Math.max(pollIntervalMs, BACKOFF_MS[Math.min(failures, BACKOFF_MS.length) - 1])
}

// Age is measured on the server clock (as_of vs server_now) plus the local time
// elapsed since the response arrived, so a wrong device clock does not matter.
export function isStale(company, snapshot, nowMs) {
    if (!snapshot || company.asOf === null) return false
    const serverNow = snapshot.serverNow === null ? snapshot.receivedAt : snapshot.serverNow
    const age = (serverNow - company.asOf) + (nowMs - snapshot.receivedAt)
    return age > snapshot.staleAfterMs
}
